import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import SearchPanel from "@widgets/SearchPanel";
import { fnGetDataSet } from "@shared/api/restApi";
import { getInitPopUp } from "@shared/utils/CommonUtils";
import { global } from "@shared/libs/Global";
import SnGrid from "@shared/components/Grid/SnGrid";
import SnTab from "@shared/components/SnTab";
import { showDialog } from "@widgets/CommonDialog";
import SnSearchBtn from "@shared/components/SnSearchBtn";
import SnLabel from "@shared/components/SnLabel";
import SnNumberBox from "@shared/components/SnNumberBox";

interface popupProps {
  selectedData?: any;
  modalRef?: any;
}

const SN_TRA_EOF_REG_001_POP_002 = forwardRef(
  ({ selectedData, modalRef }: popupProps, ref: React.Ref<any>) => {
    //#region variable
    const { userInfo } = global();
    const gridApiRef1 = useRef<any>(null); // 첫 번째  그리드 Reference 변수
    const gridApiRef2 = useRef<any>(null); // 두 번째  그리드 Reference 변수
    const gridApiRef3 = useRef<any>(null);
    const gridApiRef4 = useRef<any>(null);
    const gridApiRef5 = useRef<any>(null);
    const gridApiRef6 = useRef<any>(null);
    const searchRef = useRef<any>(null);
    //#endregion

    //#region Components useState
    const [formData, setFormData] = useState<any>();
    const [formControlData, setFormControlData] = useState<any[]>([]);

    const [columns1, setColums1] = useState<any[]>([]);
    const [columns2, setColums2] = useState<any[]>([]);
    const [columns3, setColums3] = useState<any[]>([]);
    const [columns4, setColums4] = useState<any[]>([]);
    const [columns5, setColums5] = useState<any[]>([]);
    const [columns6, setColums6] = useState<any[]>([]);

    const [dataSource1, setDataSource1] = useState<any[]>([]);
    const [dataSource2, setDataSource2] = useState<any[]>([]);
    const [dataSource3, setDataSource3] = useState<any[]>([]);
    const [dataSource4, setDataSource4] = useState<any[]>([]);
    const [dataSource5, setDataSource5] = useState<any[]>([]);
    const [dataSource6, setDataSource6] = useState<any[]>([]);

    const [selectedTabPage, setTapPage] = useState<string>("1");

    const inputRefs = useRef<any>([]);

    const [gridFocus1, setGridFocus1] = useState(false);
    const [gridFocus2, setGridFocus2] = useState(false);
    const [gridFocus3, setGridFocus3] = useState(false);
    const [gridFocus4, setGridFocus4] = useState(false);
    const [gridFocus5, setGridFocus5] = useState(false);
    const [gridFocus6, setGridFocus6] = useState(false);
    //#endregion

    // useImperativeHandle(ref, () => ({
    //   getSelectedRow: () => [
    //     gridApiRef1.current?.getSelectedRows() || [],
    //     gridApiRef2.current?.getCheckedRows() || [],
    //     gridApiRef3.current?.getSelectedRows() || [],
    //     gridApiRef4.current?.getCheckedRows() || [],
    //     gridApiRef5.current?.getSelectedRows() || [],
    //     gridApiRef6.current?.getCheckedRows() || [],
    //   ],
    // }));

    useImperativeHandle(ref, () => ({
      getSelectedRow: () => {
        return selectedTabPage === "1"
          ? [
              gridApiRef1.current?.getSelectedRows() || [],
              gridApiRef2.current?.getCheckedRows() || [],
            ]
          : selectedTabPage === "2"
            ? [
                gridApiRef3.current?.getSelectedRows() || [],
                gridApiRef4.current?.getCheckedRows() || [],
              ]
            : [
                gridApiRef5.current?.getSelectedRows() || [],
                gridApiRef6.current?.getCheckedRows() || [],
              ];
      },
      checkvalidity: () => "validation check",
    }));

    useEffect(() => {
      const fetchform = async () => {
        try {
          const rtn: any = await getInitPopUp("SN_TRA_EOF_REG_001_POP_002", {});
          const mergedData: any = { ...rtn.formData, ...selectedData };
          setFormControlData(rtn.formControlData); // 조회조건 항목 설정

          setFormData(mergedData); // 조회조건 초기값
          setColums1(rtn.grid.grid1); // H그리드 항목 설정
          setColums2(rtn.grid.grid2); // L그리드 항목 설정
          setColums3(rtn.grid.grid3);
          setColums4(rtn.grid.grid4);
          setColums5(rtn.grid.grid5);
          setColums6(rtn.grid.grid6);
        } catch (error) {}
      };
      fetchform();
    }, [userInfo]);

    useEffect(() => {
      if (selectedTabPage === "1") {
        gridApiRef1.current.selectAndFocusRow(0);
        gridApiRef2.current.selectAndFocusRow(0);
        setGridFocus1(false);
        setGridFocus2(false);
      } else if (selectedTabPage === "2") {
        gridApiRef3.current.selectAndFocusRow(0);
        gridApiRef4.current.selectAndFocusRow(0);
        setGridFocus3(false);
        setGridFocus4(false);
      } else if (selectedTabPage === "3") {
        gridApiRef5.current.selectAndFocusRow(0);
        gridApiRef6.current.selectAndFocusRow(0);
        setGridFocus5(false);
        setGridFocus6(false);
      }
    }, [
      gridFocus1,
      gridFocus2,
      gridFocus3,
      gridFocus4,
      gridFocus5,
      gridFocus6,
    ]);

    //#region Button Event
    const onSearch = async () => {
      const fetchdatasource = async () => {
        try {
          const param = {
            id: "SN_TRA_EOF_REG_001_POP_002_01",
            params: searchRef.current.getFormdata(),
          };
          setDataSource1([]);
          setDataSource2([]);
          setDataSource3([]);
          setDataSource4([]);
          setDataSource5([]);
          setDataSource6([]);

          const data: any = await fnGetDataSet(param);

          setDataSource1(data[0]);
          setDataSource2(data[1] || []);
          setDataSource3(data[2] || []);
          setDataSource4(data[3] || []);
          setDataSource5(data[4] || []);
          setDataSource6(data[5] || []);

          if (data[0] && data[0].length > 0) {
            //const selectNoEst = data[0][0];
            await new Promise((resolve) => setTimeout(resolve, 50));

            setGridFocus1(true);
            setGridFocus2(true);
            setGridFocus3(true);
            setGridFocus4(true);
            setGridFocus5(true);
            setGridFocus6(true);
          }

          switch (selectedTabPage) {
            case "1":
              gridApiRef1.current?.selectAndFocusRow(0);
              break;
            case "2":
              gridApiRef3.current?.selectAndFocusRow(0);
              break;
            case "3":
              gridApiRef5.current?.selectAndFocusRow(0);
              break;
          }

          gridApiRef1.current.resetUpdate();
          gridApiRef2.current.resetUpdate();
          gridApiRef3.current.resetUpdate();
          gridApiRef4.current.resetUpdate();
          gridApiRef5.current.resetUpdate();
          gridApiRef6.current.resetUpdate();
        } catch (error: any) {
          showDialog("error", error.message);
        }
      };
      await fetchdatasource();
    };
    //#endregion

    //#region Event Method
    const onFocusedRowChanged1 = (row: any) => {
      const no_io = row?.no_io;
      gridApiRef2.current.applyFilters({ no_io: no_io });
      gridApiRef2.current.selectAllFiltered();
    };

    const onFocusedRowChanged2 = (row: any) => {
      const cd_cust = row?.cd_cust;
      const cd_exch = row?.cd_exch;
      const fg_trns = row?.fg_trns;
      const cd_fin = row?.cd_fin;
      gridApiRef4.current.applyFilters({
        cd_cust: cd_cust,
        cd_exch: cd_exch,
        fg_trns: fg_trns,
        cd_fin: cd_fin,
      });
      gridApiRef4.current.selectAllFiltered();
    };

    const onFocusedRowChanged3 = (row: any) => {
      const no_req = row?.no_req;
      gridApiRef6.current.applyFilters({ no_io: no_req });
      gridApiRef6.current.selectAllFiltered();
    };

    const onTabChanged = (index: string) => {
      setTapPage(index);
      // Optional: reset filters on tab change
      setTimeout(() => {
        if (index === "1") gridApiRef1.current?.selectAndFocusRow(0);
        else if (index === "2") gridApiRef3.current?.selectAndFocusRow(0);
        else if (index === "3") gridApiRef5.current?.selectAndFocusRow(0);
      }, 50);
    };

    //#endregion

    //#region UI
    return (
      <div>
        <div>
          <SearchPanel
            ref={searchRef}
            data={formData}
            controls={formControlData}
            popupRef={ref}
          ></SearchPanel>
        </div>
        <div style={{ textAlign: "center" }}>
          <SnSearchBtn
            text={"조회"}
            onClick={onSearch}
            sx={{ width: 80, marginTop: 1.5 }}
            spinner={true}
          />
        </div>

        <div>
          <SnTab
            titles={["출하번호별", "고객사별", "출하의뢰번호별"]}
            width={"100%"}
            onTabChanged={onTabChanged}
            body={[
              <div style={{ height: "28vh", marginTop: "10px" }}>
                <SnGrid
                  ref={gridApiRef1}
                  columnConfig={columns1}
                  rowData={dataSource1}
                  rowSelection="single"
                  isEditable={false}
                  enableAddRow={false}
                  ischeckboxSelection={true}
                  onFocusedRowChanged={onFocusedRowChanged1}
                />

                <SnGrid
                  ref={gridApiRef2}
                  columnConfig={columns2}
                  rowData={dataSource2}
                  rowSelection="multiple"
                  isEditable={false}
                  enableAddRow={false}
                  ischeckboxSelection={true}
                />
              </div>,
              <div style={{ height: "28vh", marginTop: "10px" }}>
                <SnGrid
                  ref={gridApiRef3}
                  columnConfig={columns3}
                  rowData={dataSource3}
                  rowSelection="single"
                  isEditable={false}
                  enableAddRow={false}
                  ischeckboxSelection={true}
                  onFocusedRowChanged={onFocusedRowChanged2}
                />
                <SnGrid
                  ref={gridApiRef4}
                  columnConfig={columns4}
                  rowData={dataSource4}
                  rowSelection="multiple"
                  isEditable={false}
                  enableAddRow={false}
                  ischeckboxSelection={true}
                />
              </div>,

              <div style={{ height: "28vh", marginTop: "10px" }}>
                <SnGrid
                  ref={gridApiRef5}
                  columnConfig={columns5}
                  rowData={dataSource5}
                  rowSelection="single"
                  isEditable={false}
                  enableAddRow={false}
                  ischeckboxSelection={true}
                  onFocusedRowChanged={onFocusedRowChanged3}
                />
                <SnGrid
                  ref={gridApiRef6}
                  columnConfig={columns6}
                  rowData={dataSource6}
                  rowSelection="multiple"
                  isEditable={false}
                  enableAddRow={false}
                  ischeckboxSelection={true}
                />
              </div>,
            ]}
          />
        </div>
      </div>
    );
    //#endregion
  }
);

export default SN_TRA_EOF_REG_001_POP_002;
